import React from 'react';

const PageTemplate = ({ title, subtitle, children }) => {
  return (
    <div className="page-content">
      <section className="page-hero">
        <div className="container">
          <h1>{title}</h1>
          {subtitle && <p>{subtitle}</p>}
        </div>
      </section>
      {children}
    </div>
  );
};

export default PageTemplate;
